<template>
	<div v-if="user.hasRole(['manager', 'admin'])">
		<datatable
			ref="datatable"
			:isAuth="isAuth"
			:user="user">
		</datatable>
	</div>
</template>

<script>
	import Datatable from './Datatable.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'datatable': Datatable,
		},
		data () {
			return {
				//
			}
		},
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/accounts/views/Index.vue